import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=f126ebbe&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f126ebbe')) {
      api.createRecord('f126ebbe', component.options)
    } else {
      api.reload('f126ebbe', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=f126ebbe&", function () {
      api.rerender('f126ebbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dcuZ8QvOZUD2/JS/comp/ImgFallback.vue"
export default component.exports